// Story 8.3 (ADO-2012), Task 13.1 (card 09, D-24): the send was refused because the cart changed
// while the Shopper reviewed it. The design-system Banner, inline warning (Figma `Type="Warning"`,
// `Layout="Inline"`, `Action=false`), above the Submit card, with the designer's copy (DV-3); the
// text says "line" or "lines" by how many lines are marked (D-24). The lines carry their own marks
// (the basket store's conflicts, shown by the cart rows). It goes when the Shopper changes the cart
// or sends again (8.6's refusal rule) and when card 10 replaces it.
//
// ADO-3257 (story D-5): when the cart was sent after the revision the Shopper reviewed, the title
// is card 10's instead ("This order was sent at 11:42", `formatSentTime`: Dublin time, the time
// alone when it is today, "today" being the day the refusal was noted), above card 09's own text,
// which is left out when no line is highlighted.

import { Banner } from '../../design-system';
import { useOrderSubmissionStore } from '../../basket/useOrderSubmissionStore';
import { formatSentTime } from '../../shared/deliveryDayDisplay';

export function ChangedWhileReviewingBanner({ depotId }: { readonly depotId: string }) {
  const changed = useOrderSubmissionStore((s) =>
    s.phase === 'failed' && s.depotId === depotId ? (s.error?.changedWhileReviewing ?? null) : null,
  );
  if (changed === null) return null;
  const { lineCount, sent } = changed;
  return (
    <Banner
      type="warning"
      title={
        sent === undefined
          ? 'This cart changed while you were reviewing it'
          : `This order was sent at ${formatSentTime(sent.sentAt, sent.notedAt)}`
      }
    >
      {lineCount === 0
        ? null
        : `Check the highlighted ${lineCount === 1 ? 'line' : 'lines'}, then submit again.`}
    </Banner>
  );
}
